import PortalTextField from './PortalTextField.js';

export default PortalTextField;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalTextField/index.js